import { cn as e } from "../shared/utils.js";
import { Button as t } from "../button/primitive/button.js";
import { XCloseIcon as n } from "@systemeio/icons";
import { forwardRef as r } from "react";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
import { mergeProps as o } from "@base-ui/react/merge-props";
import { useRender as s } from "@base-ui/react/use-render";
import { cva as c } from "class-variance-authority";
import { Dialog as l } from "@base-ui/react/dialog";
//#region src/modal/index.tsx
var u = (e) => /* @__PURE__ */ i(l.Root, { ...e }), d = r((e, t) => /* @__PURE__ */ i(l.Portal, {
	ref: t,
	...e
})), f = r((e, t) => /* @__PURE__ */ i(l.Trigger, {
	ref: t,
	"data-slot": "modal-trigger",
	"data-testid": "modal-trigger",
	...e
})), p = r((e, t) => /* @__PURE__ */ i(l.Close, {
	ref: t,
	"data-slot": "modal-close",
	"data-testid": "modal-close",
	...e
})), m = r(({ className: t, ...n }, r) => /* @__PURE__ */ i(l.Backdrop, {
	ref: r,
	className: e("bg-system-secondary-950/25 fixed inset-0 z-50 backdrop-blur-sm transition-all duration-200 data-ending-style:opacity-0 data-starting-style:opacity-0", t),
	"data-slot": "modal-backdrop",
	"data-testid": "modal-backdrop",
	...n
})), h = r(({ className: t, ...n }, r) => /* @__PURE__ */ i(l.Viewport, {
	ref: r,
	className: e("fixed inset-0 z-50 grid place-items-center p-4", t),
	"data-slot": "modal-viewport",
	"data-testid": "modal-viewport",
	...n
})), g = c("bg-bg-primary text-text-primary border-border-100 relative flex max-h-full min-h-0 w-full origin-center scale-[calc(1-0.1*var(--nested-dialogs))] flex-col border opacity-[calc(1-var(--nested-dialogs))] transition-[scale,opacity,translate] duration-200 ease-in-out will-change-transform outline-none data-ending-style:scale-98 data-ending-style:opacity-0 data-starting-style:scale-98 data-starting-style:opacity-0", {
	variants: { size: {
		sm: "min-w-[min(500px,100%)] max-w-[min(500px,100%)] rounded-[10px]",
		md: "min-w-[min(700px,100%)] max-w-[min(700px,100%)] rounded-xl",
		lg: "min-w-[min(1200px,100%)] max-w-[min(1200px,100%)] rounded-xl"
	} },
	defaultVariants: { size: "md" }
}), _ = r(({ className: r, children: o, size: s, showCloseButton: c = !0, backdropProps: u, closeProps: f, portalProps: _, viewportProps: v, ...y }, b) => /* @__PURE__ */ a(d, {
	..._,
	children: [/* @__PURE__ */ i(m, { ...u }), /* @__PURE__ */ i(h, {
		...v,
		children: /* @__PURE__ */ a(l.Popup, {
			ref: b,
			className: e(g({ size: s }), r),
			"data-slot": "modal-popup",
			"data-testid": "modal-popup",
			...y,
			children: [o, c && /* @__PURE__ */ i(p, {
				"aria-label": "Close",
				className: "absolute end-8 top-6",
				render: /* @__PURE__ */ i(t, {
					variant: "ghost-gray",
					size: "icon-sm"
				}),
				...f,
				children: /* @__PURE__ */ i(n, { className: "text-icon-primary size-[18px]" })
			})]
		})
	})]
})), v = r(({ className: t, render: n, ...r }, i) => {
	let a = {
		className: e("py-6 px-8 in-[[data-slot=modal-popup]:has([data-slot=dialog-panel])]:pb-0.75 border-b border-border-100", t),
		"data-slot": "modal-header",
		"data-testid": "modal-header",
		ref: i
	};
	return s({
		defaultTagName: "div",
		props: o(a, r),
		render: n
	});
}), y = r(({ className: t, render: n, ...r }, i) => {
	let a = {
		className: e("flex gap-3 py-6 px-8 flex-row rounded-b-[inherit] justify-end bg-bg-primary", t),
		"data-slot": "modal-footer",
		"data-testid": "modal-footer",
		ref: i
	};
	return s({
		defaultTagName: "div",
		props: o(a, r),
		render: n
	});
}), b = r(({ className: t, ...n }, r) => /* @__PURE__ */ i(l.Title, {
	ref: r,
	className: e("text-text-primary text-3xl font-semibold", t),
	"data-slot": "modal-title",
	"data-testid": "modal-title",
	...n
})), x = r(({ className: t, ...n }, r) => /* @__PURE__ */ i(l.Description, {
	ref: r,
	className: e("text-text-tertiary text-base", t),
	"data-slot": "modal-subtitle",
	"data-testid": "modal-subtitle",
	...n
}));
u.displayName = "Modal.Root", d.displayName = "Modal.Portal", f.displayName = "Modal.Trigger", p.displayName = "Modal.Close", m.displayName = "Modal.Backdrop", h.displayName = "Modal.Viewport", _.displayName = "Modal.Popup", v.displayName = "Modal.Header", y.displayName = "Modal.Footer", b.displayName = "Modal.Title", x.displayName = "Modal.Subtitle";
var S = {
	Root: u,
	Portal: d,
	Trigger: f,
	Close: p,
	Backdrop: m,
	Viewport: h,
	Popup: _,
	Header: v,
	Footer: y,
	Title: b,
	Subtitle: x,
	createHandle: l.createHandle
};
//#endregion
export { S as Modal };
